import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>
                    Nieuw jaar, nieuw jij: een realistische kijk op (duurzame)
                    goede voornemens!
                </title>
                <link rel="canonical" href={route("blogs.sixty")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Het nieuwe jaar is aangebroken en traditioneel is dit de tijd waarin we onszelf beloven om beter voor ons lichaam te zorgen. Gewichtsverlies staat vaak bovenaan de lijst van goede voornemens. Maar hoe scheid je de zin van de onzin als het gaat om effectieve manieren om gewicht te verliezen? In dit artikel duiken we in wat de wetenschap zegt over succesvolle strategieën voor gewichtsverlies."
                />
                <meta
                    property="og:description"
                    content="Het nieuwe jaar is aangebroken en traditioneel is dit de tijd waarin we onszelf beloven om beter voor ons lichaam te zorgen. Gewichtsverlies staat vaak bovenaan de lijst van goede voornemens. Maar hoe scheid je de zin van de onzin als het gaat om effectieve manieren om gewicht te verliezen? In dit artikel duiken we in wat de wetenschap zegt over succesvolle strategieën voor gewichtsverlies."
                />
                <meta property="og:url" content={route("blogs.sixty")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Nieuw jaar, nieuw jij: een realistische kijk op (duurzame) goede voornemens! - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/voornemens.png"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/voornemens.webp"
                                    type="image/webp"
                                    alt="Voornemens"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/voornemens.png"
                                    type="image/jpeg"
                                    alt="Voornemens"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/voornemens.png"
                                    alt="Voornemens"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Nieuw jaar, nieuw jij: een realistische kijk op
                        (duurzame) goede voornemens!
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Het nieuwe jaar is aangebroken en traditioneel is dit de
                        tijd waarin we onszelf beloven om beter voor ons lichaam
                        te zorgen. Gewichtsverlies staat vaak bovenaan de lijst
                        van goede voornemens. Maar hoe scheid je de zin van de
                        onzin als het gaat om effectieve manieren om gewicht te
                        verliezen? In dit artikel duiken we in wat de wetenschap
                        zegt over succesvolle strategieën voor gewichtsverlies.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat werkt echt?
                    </h2>
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-2xl sm:text-2xl break-words">
                        Kleine, duurzame veranderingen
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Het is verleidelijk om te kiezen voor een snelle
                        oplossing, maar onderzoek toont aan dat kleine, duurzame
                        veranderingen in je levensstijl veel effectiever zijn op
                        de lange termijn. Dit betekent dat je beter stap voor
                        stap je eet- en beweegpatroon kunt aanpassen.
                    </p>
                    {/* -- */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-2xl sm:text-2xl break-words">
                        Gebalanceerde voeding
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Een gezond voedingspatroon dat alle voedingsgroepen
                        omvat, is cruciaal.{" "}
                        <a
                            href={route("blogs.forty-seven")}
                            className="text-we-are-yellow"
                            target="_blank"
                        >
                            Crashdiëten
                        </a>{" "}
                        waarbij je hele voedingsgroepen uitsluit, zijn vaak niet
                        vol te houden en kunnen zelfs schadelijk zijn voor je
                        gezondheid (Mann et al., 2007).
                    </p>
                    {/*  */}

                    <h3 className="text-white mt-8 font-bold uppercase xs:text-2xl sm:text-2xl break-words">
                        Regelmatige lichaamsbeweging
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Lichaamsbeweging is een andere sleutel tot succesvol
                        gewichtsverlies. Het gaat niet alleen om calorieën
                        verbranden; het helpt ook bij het behouden van{" "}
                        <a
                            href={route("blogs.thirty-nine")}
                            className="text-we-are-yellow"
                            target="_blank"
                        >
                            spiermassa
                        </a>{" "}
                        tijdens het afvallen, wat belangrijk is voor het
                        behouden van een gezond metabolisme (Willis et al.,
                        2012).
                    </p>

                    <h3 className="text-white mt-8 font-bold uppercase xs:text-2xl sm:text-2xl break-words">
                        Gedragsverandering
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Het aanpassen van je{" "}
                        <a
                            href={route("blogs.fifty-two")}
                            className="text-we-are-yellow"
                            target="_blank"
                        >
                            gedrag
                        </a>{" "}
                        en gewoontes is essentieel voor gewichtsverlies.
                        Technieken zoals zelfmonitoring, het stellen van
                        realistische doelen en het zoeken van sociale steun
                        kunnen helpen (Wing & Phelan, 2005).
                    </p>
                    {/*  */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat werkt minder goed?
                    </h2>
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-2xl sm:text-2xl break-words">
                        Snelle oplossingen
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Producten die snelle resultaten beloven, zoals '
                        <a
                            href={route("blogs.seventeenth")}
                            className="text-we-are-yellow"
                            target="_blank"
                        >
                            fat burners
                        </a>
                        ' of extreme diëten, leveren vaak niet de beloofde
                        resultaten op en kunnen ongezond zijn. Bovendien is het
                        gewicht dat je verliest vaak tijdelijk.
                    </p>
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-2xl sm:text-2xl break-words">
                        Te strikte diëten
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Diëten die te restrictief zijn, kunnen leiden tot een
                        verstoorde relatie met voedsel en zijn vaak niet
                        duurzaam. Dit kan resulteren in het bekende{" "}
                        <a
                            href={route("blogs.eighth")}
                            className="text-we-are-yellow"
                            target="_blank"
                        >
                            jojo-effect
                        </a>{" "}
                        (Field et al., 2003).
                    </p>
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-2xl sm:text-2xl break-words">
                        Het negeren van mentale gezondheid
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Gewichtsverlies is niet alleen een fysiek proces; je
                        mentale welzijn is net zo belangrijk. Stress en{" "}
                        <a
                            href={route("blogs.tenth")}
                            className="text-we-are-yellow"
                            target="_blank"
                        >
                            slaaptekort
                        </a>{" "}
                        kunnen bijvoorbeeld gewichtsverlies in de weg staan
                        (Taheri et al., 2004).
                    </p>
                    {/*  */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Hoe maak je een succesvol plan?
                    </h2>
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-2xl sm:text-2xl break-words">
                        Stel realistische doelen
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Wees realistisch in wat je kunt bereiken. Een bescheiden
                        gewichtsverlies van 5-10% van je totale lichaamsgewicht
                        kan al aanzienlijke gezondheidsvoordelen opleveren
                        (Blackburn, 1995).
                    </p>
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-2xl sm:text-2xl break-words">
                        Vind wat voor jou werkt
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Iedereen is anders, dus wat voor de een werkt, werkt
                        niet per se voor de ander. Experimenteer met
                        verschillende gezonde voedingsmiddelen en activiteiten
                        totdat je vindt wat bij jou past.
                    </p>
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-2xl sm:text-2xl break-words">
                        Wees geduldig en vergevingsgezind
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Gewichtsverlies kost tijd en soms ga je de mist in. Dat
                        is oké. Het belangrijkste is dat je leert van je fouten
                        en doorgaat.
                    </p>
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-2xl sm:text-2xl break-words">
                        Zoek steun
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Of het nu vrienden, familie of een professionele coach
                        is, steun kan een groot verschil maken in je reis naar
                        een gezonder gewicht.
                    </p>
                    {/*  */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Conclusie
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Gewichtsverlies is een persoonlijke reis die tijd en
                        toewijding vereist. Het is belangrijk om te onthouden
                        dat er geen one-size-fits-all oplossing is. Door je te
                        richten op duurzame veranderingen, een gebalanceerd
                        dieet, regelmatige lichaamsbeweging en
                        gedragsaanpassingen, kun je een gezonder gewicht
                        bereiken en behouden. Wees lief voor jezelf, stel
                        realistische doelen en onthoud dat elke stap, hoe klein
                        ook, een stap in de goede richting is.
                    </p>
                    {/*  */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-2xl sm:text-2xl break-words">
                        Referenties
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        De informatie in dit artikel is gebaseerd op betrouwbare
                        bronnen uit de literatuur.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Blackburn, G. (1995). Effect of degree of weight loss on
                        health benefits. Obesity Research, 3(S2), 211s-216s.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Field, A. E., Austin, S. B., Taylor, C. B., Malspeis,
                        S., Rosner, B., Rockett, H. R., ... & Colditz, G. A.
                        (2003). Relation between dieting and weight change among
                        preadolescents and adolescents. Pediatrics, 112(4),
                        900-906.
                    </p>w
                    <p className="mt-4 text-gray-100 break-words">
                        Mann, T., Tomiyama, A. J., Westling, E., Lew, A. M.,
                        Samuels, B., & Chatman, J. (2007). Medicare's search for
                        effective obesity treatments: Diets are not the answer.
                        American Psychologist, 62(3), 220.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Taheri, S., Lin, L., Austin, D., Young, T., & Mignot, E.
                        (2004). Short sleep duration is associated with reduced
                        leptin, elevated ghrelin, and increased body mass index.
                        PLoS Medicine, 1(3), e62.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Willis, L. H., Slentz, C. A., Bateman, L. A., Shields,
                        A. T., Piner, L. W., Bales, C. W., ... & Kraus, W. E.
                        (2012). Effects of aerobic and/or resistance training on
                        body mass and fat mass in overweight or obese adults.
                        Journal of Applied Physiology, 113(12), 1831-1837.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Wing, R. R., & Phelan, S. (2005). Long-term weight loss
                        maintenance. The American Journal of Clinical Nutrition,
                        82(1), 222S-225S.
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
